import React from 'react'

import { css } from 'design'

import { ComposerAttachIcon } from '../../../../images'
import { ToolbarButton } from './toolbar_button'

export const attachIconStyles = css({
  strokeWidth: '2px',
  variants: {
    activeType: {
      message: {
        stroke: '$grey950',
      },
      note: {
        stroke: '$yellow900',
        '&:hover': {
          stroke: '$grey900',
        },
      },
    },
  },
})

export const AttachFilesToolbarButton = ({
  activeType = 'message',
  desktop = true,
}: {
  activeType?: 'message' | 'note'
  desktop?: boolean
}) => (
  <ToolbarButton
    data-trix-action="attachFiles"
    title="Attach Files"
    tabIndex={-1}
    activeType={activeType}
    desktop={desktop}
  >
    <ComposerAttachIcon className={attachIconStyles({ activeType })} />
  </ToolbarButton>
)
